<template>
<base-modal title="Edit Image">
  <form>
    <div class="columns">
      <div class="column">
        <file-input required
          button-text="Choose a file"
          class="is-boxed"
          hint="712px x 1003px"
          @select="setFile"
          :error="errors.file">
          Image
        </file-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button 
          v-bind="{ working }"
          @submit="save"
          class="is-success is-rounded">
          Save
        </submit-button>
      </div>
    </div>
  </form>
</base-modal>  
</template>

<script>
import { saveFile } from '@/api/article'

export default {
  
  props: {
    articleId: Number
  },

  data: () => ({
    working: false,
    file: ''
  }),

  methods: {
    setFile(file) {
      this.file = file
    },

    save() {
      this.working = true
      saveFile({
        articleId: this.articleId,
        file: this.file 
      }, () => {
        this.$toast.success('Changes saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }
}
</script>
